// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'

export default {
    name: 'SmallBusinessDisclaimer',
    components: {
        IconArrowBack,
        IconBase,
        BackButton,
        NextButton
    },
    data() {
        return {
        }
    },
    mounted(){
        this.$parent.CurrentProcess = "EducatorInsuranceProcess";
        this.ValidateSessionData();
        this.$parent.CheckWindowPathName();
        this.$parent.RemoveClassFrom('button-item','b-btn');
        this.$parent.AddClassFrom('button-item','wh-btn');
        if(this.$parent.EducatorInsuranceProcess.small_business_disclaimer == true){
            document.getElementById('yes').classList.add("b-btn");
            document.getElementById('yes').classList.remove("wh-btn");
        }else if(this.$parent.EducatorInsuranceProcess.small_business_disclaimer == false){
            document.getElementById('no').classList.add("b-btn");
            document.getElementById('no').classList.remove("wh-btn");
        }
    },
    methods: { 
        ValidateSmallBusinessDisclaimer(_smallbusinessdisclaimer) {
          this.$parent.EducatorInsuranceProcess.small_business_disclaimer = _smallbusinessdisclaimer;
          /*if(this.$parent.ServiceCurrentStep == 7) { 
              this.$parent.ServiceCurrentStep++;
          }*/
          this.$parent.EducatorNextStep(6,"RegisteredForGST");
        },
        ValidateSessionData() {
            if(this.$parent.EducatorInsuranceProcess.small_business_disclaimer != null) {
                if(this.$parent.EducatorInsuranceProcess.small_business_disclaimer) {
                    document.getElementById("Yes").classList.add("selected");
                } else {
                    document.getElementById("No").classList.add("selected");
                }
            }
        }
    }
}